<div class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-content">

    <div class="content">
      <div class="cp-p-24" [innerHTML]="message() | safeHtml">
      </div>
    </div>

    <div class="cp-footer">
      <button class="coupon-button" (click)="close()">
        {{ 'button_ok' | translate }}
      </button>
    </div>
  </div>
</div>
